import React from 'react';
import { Link, useHistory } from 'react-router-dom';

import Alert from '../../../../components/Alert';
import Button from '../../../../components/Button';
import StepProgress from '../../../../components/StepProgress';
import steps from '../../../../utils/steps.json';
import { PageContainer, ContainerButton } from '../../../../styles/styles';

function AguardarAnalise() {
    const successTitle = 'Você transferiu o beneficiário titular!';
    const successMessage = [
        [
            'Essa transferência de beneficiário é aplicada automaticamente aos planos de dependentes e pessoas agregadas ao titular da conta.',
            ' A partir de agora, você pode acompanhar o status da sua solicitação pela opção ',
            <Link to="/movimentacao_cadastral/movimentacoes_pendentes">
                <u>Movimentações pendentes.</u>
            </Link>,
        ],
    ];

    const history = useHistory();

    return (
        <PageContainer>
            <StepProgress steps={steps.transferirBeneficiario} activeStep={3} />

            <Alert type={3} title={successTitle} message={successMessage} />

            <ContainerButton>
                <Button id="backStep" type="secondary" onClick={() => history.push('/')}>
                    Acessar home
                </Button>

                <Button
                    id="continueStep"
                    type="primary"
                    onClick={() => history.push('/movimentacao_cadastral/selecionar_transferencia_beneficiario')}
                >
                    Transferir novo beneficiário
                </Button>
            </ContainerButton>
        </PageContainer>
    );
}

export default AguardarAnalise;
